import QRCode from 'qrcode';

export async function qrCodeDataUrl(
  url: string,
  size = 280,
): Promise<string> {
  return QRCode.toDataURL(url, {
    width: size,
    margin: 1,
    errorCorrectionLevel: 'M',
  });
}

export async function downloadQrPng(
  url: string,
  filename = 'cloudtransfer-send-qr.png',
): Promise<void> {
  const dataUrl = await qrCodeDataUrl(url, 512);
  const anchor = document.createElement('a');
  anchor.href = dataUrl;
  anchor.download = filename;
  anchor.click();
}

export async function printReceiveLink(
  label: string,
  url: string,
): Promise<void> {
  const win = window.open('', '_blank', 'noopener,noreferrer');
  if (!win) return;

  const isQr = label.toLowerCase().includes('qr');
  const qrMarkup = isQr
    ? `<div style="margin:24px 0"><img src="${await qrCodeDataUrl(
        url,
        280,
      )}" alt="QR code" style="display:block;width:280px;height:280px" /></div>`
    : '';

  win.document.open();
  win.document.write(`<!DOCTYPE html>
<html>
  <head>
    <title>${label}</title>
    <style>
      body { font-family: sans-serif; padding: 24px; color: #222; }
      h1 { margin: 0 0 16px; font-size: 24px; }
      p { margin: 0; word-break: break-all; font-size: 16px; }
      .wrap { display: flex; flex-direction: column; align-items: flex-start; }
      @media print { body { margin: 0; } }
    </style>
  </head>
  <body>
    <div class="wrap">
      <h1>${label}</h1>
      ${qrMarkup}
      <p>${url}</p>
    </div>
    <script>
      window.addEventListener('load', function () {
        setTimeout(function () {
          window.focus();
          window.print();
        }, 250);
      });
      window.addEventListener('afterprint', function () {
        window.close();
      });
    </script>
  </body>
</html>`);
  win.document.close();
}

export function downloadTextFile(
  contents: string,
  filename: string,
): void {
  const blob = new Blob([contents], {type: 'text/plain;charset=utf-8'});
  const anchor = document.createElement('a');
  anchor.href = URL.createObjectURL(blob);
  anchor.download = filename;
  anchor.click();
  URL.revokeObjectURL(anchor.href);
}
